<template>
  <div class="report-details">
    <div class="breadcrumb">
      <a-breadcrumb>
        <a-breadcrumb-item>
          <router-link to="/home">首页</router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item>
          <router-link to="/report">报告管理</router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item>报告详情</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <div class="report-details-content">
      <div class="header">
        <h2 class="name">{{ detailsData.jobsName || "" }}</h2>
        <a-row>
          <a-col :span="12">
            <div class="clearfix">
              <div class="user-name">
                {{ detailsData.patient ? detailsData.patient.patientName : "" }}
                <span class="user-sex">
                  <i class="iconfont icon-nan"></i>
                  {{
                      detailsData.patient ? detailsData.patient.sexName : ""
                  }}</span>
                <span class="disease-type" v-if="detailsData.patient && detailsData.patient.diseaseType">{{
                    detailsData.patient ? detailsData.patient.diseaseType : ""
                }}</span>
              </div>
              <span class="right-group mg-0">
                <span class="right-group-title">就诊医院:</span>
                <span class="right-group-value">{{
                    detailsData.hospital ? detailsData.hospital.deptName : ""
                }}</span>
              </span>
              <span class="right-group mg-140">
                <span class="right-group-title">协作组条码:</span>
                <span class="right-group-value">{{
                    detailsData.hosBarCode || ""
                }}</span>
              </span>
            </div>
          </a-col>
          <a-col :span="12" class="h-right-btn">
            <a-button @click="appoint()" v-auth="'10617'" type="primary">指派给机构</a-button>
            <a-button @click="appointSubmitPeople()" v-auth="'10618'" type="primary">指派提交人</a-button>
            <a-button @click="appointPeople()" v-auth="'10619'" type="primary">指派审核人</a-button>
            <a-button @click="mdToExamine()" v-auth="'106112'" type="primary">MD审核</a-button>
            <div>
              <span class="right-group">
                <span class="right-group-title">报告机构:</span>
                <span class="right-group-value">{{
                    detailsData.deptName || "- -"
                }}</span>
              </span>
              <span class="right-group">
                <span class="right-group-title">提交人:</span>
                <span class="right-group-value">{{
                    jobDetail.submitterName || "- -"
                }}</span>
              </span>
              <span class="right-group">
                <span class="right-group-title">审核人:</span>
                <span class="right-group-value">{{
                    jobDetail.verifyName || "- -"
                }}</span>
              </span>
              <!-- <span class="right-group">
                <span class="right-group-title">MD审核:</span>
                <span class="right-group-value">{{
                  detailsData.mdCheck || ""
                }}</span>
              </span> -->
            </div>
          </a-col>
        </a-row>
        <a-row class="mt-20">
          <a-col :span="8">
            <span class="record-group">
              <span class="record-title">MD审核状态</span>
              <a class="record-link" v-if="detailsData.mdCheck != '未审核'" @click="recordToggle('mdCheckToggle')">
                <a-icon v-if="mdCheckToggle.show" type="minus-square"></a-icon>
                <a-icon v-else type="plus-square"></a-icon>
              </a>
              <b class="record-none" v-else>未审核</b>
            </span>
          </a-col>
          <a-col :span="24">
            <md-to-logs v-if="mdCheckToggle.show" :itemId="detailsData.bid" :authCode1="106113" :authCode2="106114"
              ref="mdToLogs"></md-to-logs>
          </a-col>
        </a-row>
        <a-row class="mt-20">
          <a-col :span="8">
            <span class="record-group">
              <span class="record-title">备注记录</span>
              <a class="record-link" v-if="remarkData.length > 0" @click="recordToggle('remarkToggle')">{{
                  remarkToggle.text
              }}</a>
              <b class="record-none" v-else>无</b>
            </span>
          </a-col>
          <a-col :span="24">
            <div class="page-content" v-if="remarkToggle.show">
              <a-table class="hospital-table" :pagination="false" :locale="{ emptyText: '暂无数据' }"
                :columns="columnsRemark" :rowKey="(record) => record.id" :dataSource="remarkData" size="middle">
              </a-table>
            </div>
          </a-col>
        </a-row>
        <a-row class="mt-20">
          <a-col :span="8">
            <span class="record-group">
              <span class="record-title">常规检查结果</span>
              <a class="record-link" v-if="detailsData.remark" @click="recordToggle('resultToggle')">{{
                  resultToggle.text
              }}</a>
              <b class="record-none" v-else>无</b>
            </span>
          </a-col>
          <a-col :span="24">
            <div class="page-content" v-if="resultToggle.show">
              <span v-html="detailsData.remark || '- -'"></span>
            </div>
          </a-col>
        </a-row>
        <a-row class="mt-20">
          <a-col :span="8">
            <span class="record-group">
              <span class="record-title">临床诊断</span>
              <a class="record-link" v-if="detailsData.clinicalDiagnosis" @click="recordToggle('clinicalToggle')">{{
                  clinicalToggle.text
              }}</a>
              <b class="record-none" v-else>无</b>
            </span>
          </a-col>
          <a-col :span="24">
            <div class="page-content" v-if="clinicalToggle.show">
              <span v-html="detailsData.clinicalDiagnosis || '- -'"></span>
            </div>
          </a-col>
        </a-row>
        <a-row class="mt-20">
          <a-col :span="8">
            <span class="record-group">
              <span class="record-title">分子分型</span>
              <a class="record-link" v-auth="'106111'" v-if="
                !detailsData.deptName ||
                (detailsData.deptName && jobDetail.verifyStatus == '4')
              " @click="recordSaveToggle('molecularToggle')">{{ molecularToggle.text }}</a>
              <a class="record-link record-esc" v-if="molecularToggle.show"
                @click="recordSaveToggle('molecularToggle', true)">取消</a>
            </span>
          </a-col>
          <a-col :span="24">
            <div v-if="molecularToggle.show" :class="{ 'has-error': isSubmitMolecular && !molecular }">
              <a-cascader class="m-input-s" :value="molecular" :options="options" placeholder="请选择父级" change-on-select
                @change="onChange" />
              <!--<a-input class="m-input-s" v-model="molecular" placeholder="请输入分子分型，中间用英文逗号分隔"/>-->
            </div>
            <div class="page-content" v-else-if="molecular">
              {{ filterMolecularTyping(molecular) }}
            </div>
          </a-col>
        </a-row>
      </div>
      <div class="steps-div">
        <div class="examine-container">
          <a-steps :current="1" direction="vertical">
            <a-step>
              <div class="title-div" slot="title">
                <div class="btn-left">
                  <i class="iconfont icon-export1"></i>结果生成
                </div>
                <div class="right-content">
                  <div class="result-table-step1">
                    <a-table class="hospital-table" :pagination="false" :locale="{ emptyText: '暂无数据' }"
                      :columns="columnsStep1" :dataSource="dataStep1FileList" :rowKey="(record) => record.id"
                      size="middle">
                      <template slot="fileName" slot-scope="text, record">
                        <span style="
                            margin: -5px 0;
                            display: inline-block;
                            width: 160px;
                            word-break: break-all;
                          ">{{ record.fileName }}</span>
                      </template>
                      <template slot="fileSize" slot-scope="text, record">
                        <span v-if="!record.fileSize">-</span>
                        <span v-else style="margin: -5px 0" v-html="converSize(record.fileSize)"></span>
                      </template>
                      <template slot="op" slot-scope="text, record">
                        <span v-auth="'10611'" v-if="
                          record.fileUrl &&
                          record.editable &&
                          jobDetail.verifyStatus != '1' &&
                          jobDetail.verifyStatus != '3' &&
                          (userInfo.userId == jobDetail.submitterId ||
                            userInfo.userId == jobDetail.verifyId)
                        " @click="output(record, '1')" class="table-th link">编辑</span>
                        <span v-auth="'10612'" v-if="record.fileUrl && record.editable" @click="output(record, '2')"
                          class="table-th link">查看</span>
                        <span v-auth="'10612'" v-if="record.fileUrl && !record.editable" @click="chakan(record)"
                          class="table-th link">查看</span>
                        <span v-auth="'10620'" v-if="record.fileUrl && record.editable"
                          @click="downOutFile(record, 'resFile')" class="table-th link">下载</span>
                      </template>
                    </a-table>
                  </div>
                </div>
              </div>
            </a-step>
            <a-step>
              <div class="title-div" slot="title">
                <div class="btn-left">
                  <i class="iconfont icon-cloud-upload"></i>上传证据
                </div>
                <div class="right-content">
                  <div class="file-contain">
                    <!--v-auth="'10613'"-->
                    <a-upload-dragger name="file" :multiple="false" :beforeUpload="beforeUploadZJ"
                      :showUploadList="false" :disabled="currentStep != 1">
                      <p class="ant-upload-drag-icon">
                        <a-icon type="inbox" />
                      </p>
                      <p class="ant-upload-text">
                        点击或将文件拖拽到这个区域进行上传
                      </p>
                      <div>支持扩展名:pdf，pptx，docx，xlsx上传文件需小于50M</div>
                    </a-upload-dragger>
                    <div v-if="fileDataZJ && isSubmit == 0" class="file-div mt10">
                      <div class="file">
                        {{ fileDataZJ.name }}
                        <span style="
                            float: right;
                            vertical-align: middle;
                            cursor: pointer;
                            color: #428ef7;
                            width: 12px;
                          " @click="deleteInputFIle">
                          <a-icon type="close" />
                        </span>
                      </div>
                      <div class="file-btn">
                        <a-button v-auth="'10613'" v-if="isSubmit == 0" :loading="loading" @click="submitReportZJ"
                          style="width: 107px" :disabled="currentStep != 1" type="primary">提交
                        </a-button>
                      </div>
                    </div>
                    <div v-else-if="fileDataZJ" class="file-div mt10">
                      <div class="file file-show">
                        {{ fileDataZJ.name }}
                        <span v-auth="'10614'" v-if="
                          jobDetail.verifyStatus != '1' &&
                          jobDetail.verifyStatus != '3'
                        " style="
                            float: right;
                            vertical-align: middle;
                            cursor: pointer;
                            color: #428ef7;
                            width: 12px;
                          " @click="deleteInputFIle">
                          <a-icon type="close" />
                        </span>
                        <span style="
                            float: right;
                            vertical-align: middle;
                            cursor: pointer;
                            color: #428ef7;
                            width: 50px;
                          " @click="downZJFile()">下载</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </a-step>
            <a-step>
              <div class="title-div" slot="title">
                <div class="btn-left">
                  <i class="iconfont icon-audit"></i>初审
                </div>
                <div class="right-content">
                  <template>
                    <div class="step3-status-text mb15">
                      <span class="step3-text-color" v-if="jobDetail.verifyStatus == '1'">审核通过</span>
                      <span class="step3-text-color" v-else-if="jobDetail.verifyStatus == '2'">已提交</span>
                      <a-button style="width: 107px" v-auth="'10615'" v-else-if="
                        (jobDetail.verifyStatus == '4' ||
                          jobDetail.verifyStatus == '5') &&
                        userInfo.userId == jobDetail.verifyId
                      " @click="shenhe()" type="primary">审核
                      </a-button>
                      <a-button style="width: 107px" v-auth="'10615'" v-else disabled="disabled" @click="shenhe()"
                        type="primary">审核
                      </a-button>
                    </div>
                    <div v-auth="'10608'" v-if="
                      jobDetail.verifyStatus == '1' ||
                      jobDetail.verifyStatus == '3'
                    " class="step3-status-text step3-line">
                      基因检测结果 (若结果文件存在问题，可以点击“<span class="link" @click="backZJ()">退回</span>”)
                    </div>
                  </template>
                  <div class="report-list step3-list">
                    <div v-for="item in outfileList" :key="item.id" class="report-li">
                      <div class="report-li-td">
                        {{ item.submissiontFileName }}
                      </div>
                      <div class="report-li-td report-li-td-1">
                        {{ item.submissiontFileCreateTime }}
                      </div>
                      <div class="report-li-td report-li-td-1">
                        {{ item.optUserName }}
                      </div>
                      <div class="report-li-td report-li-td-2 report-li-td-icon">
                        <a-button v-auth="'10602'" @click="downOutFile(item)" type="primary"><i
                            class="iconfont icon-xiazaidaoru"></i>下载
                        </a-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </a-step>
            <a-step>
              <div class="title-div" slot="title">
                <div class="btn-left">
                  <i class="iconfont icon-audit"></i>报告生成
                </div>
                <div @click="
                  checkUpload(
                    detailsData.jobsVerifyRefVOList.length > 0 &&
                    detailsData.jobsVerifyRefVOList[0].verifyStatus ==
                    '2' &&
                    !detailsData.deptId
                  )
                " class="right-content">
                  <a-upload-dragger v-auth="'10603'" name="file" v-if="!fileData" :multiple="false" accept=".pdf"
                    :disabled="checkUploadDisabled()" :beforeUpload="beforeUpload" :showUploadList="false">
                    <!-- <a-button v-if="!fileData" style="width:107px" type="primary">选择文件</a-button> -->
                    <p class="ant-upload-drag-icon">
                      <a-icon type="inbox" />
                    </p>
                    <p class="ant-upload-text">
                      点击或将文件拖拽到这个区域进行上传
                    </p>
                    <div>支持扩展名:pdf</div>
                  </a-upload-dragger>
                  <div v-if="fileData" class="file-div">
                    <div class="file">
                      {{ fileData.name }}
                      <span style="float: right">
                        <a-icon @click="deleteInputFIleReport" type="close" />
                      </span>
                    </div>
                    <div class="file-btn">
                      <a-button v-auth="'10603'" @click="submitReport" style="width: 107px" type="primary">提交
                      </a-button>
                    </div>
                  </div>
                  <div class="report-list">
                    <div v-for="item in reportUrlVOList" :key="item.id" class="report-li">
                      <div class="report-li-td">{{ item.fileName }}</div>
                      <div class="report-li-td">{{ item.updateTime }}</div>
                      <div class="report-li-td report-li-td-icon">
                        <a-icon v-auth="'10606'" @click="deleteReportClick(item)" type="close" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </a-step>
          </a-steps>
        </div>
      </div>
      <div class="vefify-div">
        <div class="title">审核记录</div>
        <div class="table-vefify">
          <a-table class="hospital-table" :pagination="false" :locale="{ emptyText: '暂无数据' }" :columns="columns"
            :rowKey="(record) => record.id" :dataSource="dataSource" size="middle">
            <template slot="op" slot-scope="text, record">
              <span v-if="record.fileUrl" v-auth="'10616'" @click="lookUp(record.fileUrl)"
                style="margin: -5px 0; cursor: pointer; color: blue">查看</span>
              <span v-else>-</span>
            </template>
          </a-table>
        </div>
      </div>
    </div>
    <page-model @close="closeModel" :visible="pvisible">
      <check-job v-if="pvisible && isJob == 0" :id="jobDetail.id" @update="update"
        :verifyStatus="jobDetail.verifyStatus" @close="closeModel"></check-job>
      <output-file v-if="pvisible && isJob == 1 && reData" :record="reData" :step="outputStep" :jobId="reData.id"
        :verifyId="jobDetail.verifyId" :jobDetail="jobDetail" @close="closeFile"></output-file>
    </page-model>
    <page-model @close="closeModel" :visible="backZJVisible">
      <review v-if="backZJVisible && isAppoint == 3" @update="update" :review="jobDetail" @close="closeModel"></review>
      <appoint v-if="backZJVisible && isAppoint == 2" :selectedData="selectRows" @close="closeModel" @update="update">
      </appoint>
      <appoint-people v-if="backZJVisible && isAppoint == 1" :appointType="appointType" @close="closeModel"
        @update="update" :selectedData="selectRows"></appoint-people>
      <md-to-examine v-if="backZJVisible && isAppoint == 4" @close="closeModel" @update="update"
        :selectedData="selectRows" :selectedId="detailsData.bid"></md-to-examine>
    </page-model>
    <h-confirm :visible="confirmVisible" @close="closeConfirm" :loadding.sync="confirmLoadding" @ok="okClick"
      :title="currentConfirmData.title" :content="currentConfirmData.content" :desc="currentConfirmData.desc">
    </h-confirm>
  </div>
</template>

<script>
import axios from "axios";
import CheckJob from "../job/check";
import OutputFile from "../job/outputFile";
import Review from "./review";
import Appoint from "./appoint";
import AppointPeople from "./appoint-people";
import MdToExamine from "./md-to-examine.vue";
import MdToLogs from "./md-to-logs.vue";
import db from "@/common/localstorage";

const columns = [
  {
    title: "审批人",
    dataIndex: "verifyName",
  },
  {
    title: "状态",
    dataIndex: "verifyStatusName",
  },
  {
    title: "审核时间",
    dataIndex: "verifyTime",
  },
  {
    title: "审核意见",
    dataIndex: "verifyRemark",
    customRender: (text, record, index) => {
      if (!record.verifyRemark) {
        return "-";
      } else {
        return record.verifyRemark;
      }
    },
  },
  {
    title: "审核证据",
    dataIndex: "fileName",
  },
  {
    title: "操作",
    scopedSlots: { customRender: "op" },
  },
];
const columnsStep1 = [
  {
    title: "名称",
    dataIndex: "fileName",
    scopedSlots: { customRender: "fileName" },
  },
  {
    title: "类型",
    dataIndex: "fileType",
    customRender: (text, record, index) => {
      if (!record.fileType) {
        return "-";
      } else if (record.fileType == "fusion") {
        return "fusion1";
      } else if (record.fileType == "cicero") {
        return "fusion2";
      } else {
        return record.fileType;
      }
    },
  },
  {
    title: "大小",
    dataIndex: "fileSize",
    scopedSlots: { customRender: "fileSize" },
  },
  {
    title: "生成时间",
    dataIndex: "createTime",
    customRender: (text, record, index) => {
      if (!record.createTime) {
        return "-";
      } else {
        return record.createTime;
      }
    },
  },
  {
    title: "状态",
    dataIndex: "optFileStatus",
    customRender: (text, record, index) => {
      if (!record.optFileStatus) {
        return "-";
      } else {
        if (record.optFileStatus == 2) {
          return "已提交";
        } else {
          return "草稿";
        }
      }
    },
  },
  {
    title: "提交时间",
    dataIndex: "submissiontFileCreateTime",
    customRender: (text, record, index) => {
      if (!record.submissiontFileCreateTime) {
        return "-";
      } else {
        return record.submissiontFileCreateTime;
      }
    },
  },
  {
    title: "操作",
    scopedSlots: { customRender: "op" },
  },
];
const columnsRemark = [
  {
    title: "序号",
    width: "100px",
    customRender: (text, record, index) => `${index + 1}`,
  },
  {
    title: "更新时间",
    dataIndex: "updateTime",
    customRender: (text, record, index) => {
      if (!record.updateTime) {
        return "-";
      } else {
        return record.updateTime;
      }
    },
  },
  {
    title: "作者",
    dataIndex: "nickName",
    width: "15%",
    customRender: (text, record, index) => {
      if (!record.nickName) {
        return "-";
      } else {
        return record.nickName;
      }
    },
  },
  {
    title: "备注内容",
    dataIndex: "message",
    width: "50%",
    customRender: (text, record, index) => {
      if (!record.message) {
        return "-";
      } else {
        return record.message;
      }
    },
  },
];
export default {
  data() {
    return {
      columns,
      columnsStep1,
      userInfo: {},
      outputStep: 1,
      fileData: null,
      fileDataZJ: null,
      selectReportItem: null,
      detailsData: {},
      jobDetail: {},
      reData: null,
      confirmVisible: false,
      pvisible: false,
      backZJVisible: false,
      isHttpSubmit: false,
      loading: false,
      isJob: 0,
      currentStep: 0,
      isSubmit: 0,
      selectRows: [],
      appointType: 0,
      isAppoint: 0,
      molecular: "",
      options: [],
      isSubmitMolecular: false,
      currentConfirmData: {
        title: "报告删除",
        content: "您确认要删除上传的报告吗？",
        desc: "",
      },
      conAppointPeople: {
        title: "提示",
        content: "报告已指派，是否重新指派？",
        desc: "",
        operateType: "confirm-people",
      },
      conAppointRePeople: {
        title: "提示",
        content: "报告已指派，是否重新指派？",
        desc: "",
        operateType: "confirm-re-people",
      },
      dataSource: [],
      dataStep1FileList: [],
      verifyData: [],
      confirmLoadding: false,
      outfileList: [],
      reportUrlVOList: [],
      beforeUploadZJ: (file, fileList) => {
        let fileName = file.name.toString();
        let type = fileName.substring(fileName.lastIndexOf(".")).toLowerCase();
        if (type == ".pptx" || type == ".pdf" || type == ".ppt" || type == ".docx" || type == ".doc" || type == ".xlsx" || type == ".xls") {
          this.fileDataZJ = file;
          this.isSubmit = 0;
        } else {
          this.$message.error("上传证据格式支持pptx/pdf/docx/xlsx两种格式");
          this.fileDataZJ = null;
        }
        return false;
      },
      beforeUpload: (file, fileList) => {
        this.fileData = file;
        return false;
      },
      columnsRemark,
      remarkData: [],
      mdCheckToggle: {
        show: false,
        text: "查看",
      },
      remarkToggle: {
        show: false,
        text: "查看",
      },
      resultToggle: {
        show: false,
        text: "查看",
      },
      clinicalToggle: {
        show: false,
        text: "查看",
      },
      molecularToggle: {
        show: false,
        text: "编辑",
        url: "/patientitem/patientItem/molecularTyping",
      },
    };
  },
  components: {
    CheckJob,
    OutputFile,
    Review,
    Appoint,
    AppointPeople,
    MdToExamine,
    MdToLogs,
  },
  mounted() {
    this.getDetails(this.$route.query.id);
    this.getLayerLst(-1);
    this.userInfo = db.get("userInfo") || {};
  },
  methods: {
    recordToggle(key) {
      this[key].show = !this[key].show;
      this[key].text = this[key].show ? "收起" : "查看";
    },
    recordEditToggle(key) {
      this[key].show = !this[key].show;
      this[key].text = this[key].show ? "保存" : "编辑";
    },
    getLayerLst(id) {
      this.$get("mt/q/mtt").then((res) => {
        if (res.data.code == 1) {
          this.options = res.data.data;
        }
      });
    },
    findLabelName(v, list) {
      let data;
      (list || []).map((i) => {
        if (i.value === v) {
          data = [i.label];
        } else {
          const child = this.findLabelName(v, i.children);
          if (child) {
            data = [i.label, ...child];
          }
        }
      });
      return data;
    },
    filterMolecularTyping(aryId) {
      let result = this.findLabelName(aryId[aryId.length - 1], this.options);
      if (result) {
        return result.join("/");
      } else {
        return "--";
      }
    },
    onChange(value) {
      this.molecular = value;
    },
    recordSaveToggle(key, ecs) {
      if (ecs == true) {
        this.recordEditToggle(key);
        this.molecular = this.getSplitMolecular(
          this.detailsData.molecularTyping
        );
      } else if (this[key].show == false) {
        this.recordEditToggle(key);
      } else {
        this.isSubmitMolecular = true;
        if (this.molecular) {
          this.recordEditToggle(key);
          if (!this[key].show) {
            if (this.molecular != this.detailsData.molecularTyping) {
              let mt =
                this.molecular.length == 0 ? [] : this.molecular.join(",");
              this.$put("/patientitem/patientItem/molecularTyping", {
                id: this.detailsData.bid,
                molecular: mt,
              }).then(
                (res) => {
                  if (res.data.code == 1) {
                    this.$message.success(res.data.message);
                    this.detailsData.molecularTyping = mt;
                  } else {
                    this.$message.error(res.data.message);
                  }
                },
                (error) => {
                  this.$message.error(
                    error.response.data.message || "设置分子分型成功失败!"
                  );
                }
              );
            }
          }
        }
      }
    },
    appointSubmitPeople() {
      this.appointType = 0;
      if (this.selectRows.length > 0) {
        let flag = 0;
        for (let val of this.selectRows) {
          if (
            val.jobsVO.verifyStatus == 1 ||
            val.jobsVO.verifyStatus == 3 ||
            val.jobsVO.verifyStatus == 5
          ) {
            flag = 1;
            break;
          } else if (
            (val.jobsVO.verifyStatus == 0 ||
              val.jobsVO.verifyStatus == 2 ||
              val.jobsVO.verifyStatus == 4) &&
            val.jobsVO.submitterId
          ) {
            flag = 2;
            break;
          } else {
            flag = 0;
          }
        }
        if (flag == 0) {
          this.isAppoint = 1;
          this.backZJVisible = true;
        } else if (flag == 1) {
          this.$message.error("此状态不可指派");
        } else if (flag == 2) {
          this.currentConfirmData = this.conAppointPeople;
          this.confirmVisible = true;
        }
      } else {
        this.$message.error("请选择数据后进行指派");
      }
    },
    appointPeople() {
      this.appointType = 1;
      if (this.selectRows.length > 0) {
        let flag = 0;
        for (let val of this.selectRows) {
          if (val.jobsVO.verifyId) {
            flag = 1;
            break;
          } else {
            flag = 0;
          }
        }
        if (flag == 1) {
          this.currentConfirmData = this.conAppointRePeople;
          this.confirmVisible = true;
        } else {
          this.isAppoint = 1;
          this.backZJVisible = true;
        }
      } else {
        this.$message.error("请选择数据后进行指派");
      }
    },
    appoint() {
      this.isAppoint = 2;
      this.backZJVisible = true;
    },
    mdToExamine() {
      if (this.selectRows.length == 0) {
        this.$message.warning("请选择数据后进行MD审核");
        return;
      } else {
        this.isAppoint = 4;
        this.backZJVisible = true;
      }
    },
    // closeModel() {
    //   this.isAppoint = 0;
    //   this.visible = false;
    //   this.getList();
    // },
    //审核记录-查看pdf pptx
    lookUp(item) {
      if (item) {
        let uploadFile = this.$db.get("uploadFile");
        window.open(uploadFile.fileHost + item);
      } else {
        this.$message.error("文件路径不存在");
      }
    },
    chakan(record) {
      let uploadFile = this.$db.get("uploadFile");
      window.open(uploadFile.fileHost + record.fileUrl);
    },
    output(record, step) {
      this.reData = JSON.parse(JSON.stringify(record));
      this.isJob = 1;
      this.outputStep = step * 1;
      this.pvisible = true;
    },
    closeModel() {
      this.isAppoint = 0;
      this.pvisible = false;
      this.backZJVisible = false;
    },
    update(step) {
      this.currentStep = step;
      this.getDetails(this.$route.query.id);
      this.jobsVerifyList();
      if (this.mdCheckToggle.show) {
        this.$refs.mdToLogs.getComments();
      }
    },
    closeFile() {
      this.pvisible = false;
      this.getJobOutfileListByJobId(this.detailsData.jobsId);
    },
    //根据字节获取大小
    converSize(limit) {
      var size = "";
      var limit = limit;
      if (typeof limit == "string") {
        limit = parseInt(limit);
      }
      if (limit < 0.1 * 1024) {
        //如果小于0.1KB转化成B
        size = limit.toFixed(2) + "";
      } else if (limit < 0.1 * 1024 * 1024) {
        //如果小于0.1MB转化成KB
        size = (limit / 1024).toFixed(2) + "KB";
      } else if (limit < 0.1 * 1024 * 1024 * 1024) {
        //如果小于0.1GB转化成MB
        size = (limit / (1024 * 1024)).toFixed(2) + "MB";
      } else {
        //其他转化成GB
        size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB";
      }
      var sizestr = size + "";
      var len = sizestr.indexOf(".");
      var dec = sizestr.substr(len + 1, 2);
      if (dec == "00") {
        //当小数点后为00时 去掉小数部分
        return sizestr.substring(0, len) + sizestr.substr(len + 3, 2);
      }
      return sizestr;
    },
    deleteInputFIleReport() {
      this.fileData = null;
    },
    deleteInputFIle() {
      if (this.jobDetail.evidenceUrl) {
        this.$post("/fileupload/deleteFile", {
          fileUrl: this.jobDetail.evidenceUrl,
          optType: 0,
          bid: this.jobDetail.id,
        }).then((res) => {
          if (res.data.code == 1) {
            this.fileDataZJ = null;
            this.isSubmit = 0;
            this.jobDetail.evidenceUrl = null;
            this.$message.success("文件删除成功");
          } else {
            this.$message.error(res.data.message);
          }
        });
      } else {
        this.fileDataZJ = null;
        this.isSubmit = 0;
      }
    },
    deleteReportClick(item) {
      this.selectReportItem = item;
      this.confirmVisible = true;
    },
    checkUpload(status) {
      if (status) {
        this.$message.warning("请先去指派报告机构");
      }
    },
    /**
     * 报告生成-上传报告组件disabled判断 
     */
    checkUploadDisabled() {
      let disabled = true;
      /*
      (detailsData.jobsVerifyRefVOList &&
                        detailsData.jobsVerifyRefVOList.length > 0 &&
                        detailsData.jobsVerifyRefVOList[0].verifyStatus ==
                          '2') ||
                      !detailsData.deptId ||
                      !detailsData.molecularTyping*/
      if (this.detailsData.jobsVO) {
        if ((this.detailsData.jobsVO.verifyStatus == '1' || this.detailsData.jobsVO.verifyStatus == '3') &&
          this.detailsData.deptId &&
          this.detailsData.molecularTyping) {
          disabled = false;
        } else {
          disabled = true;
        }
      } else {
        disabled = true;
      }
      return disabled;
    },
    deleteReport() {
      this.$delete(
        "report/report",
        { reportUrlId: this.selectReportItem.id },
        { "Content-Type": "application/json" }
      ).then(
        (res) => {
          if (res.data.code == 1) {
            this.confirmLoadding = false;
            this.getDetails(this.$route.query.id);
            this.$message.success("文件删除成功！");
            this.confirmVisible = false;
          } else {
            this.confirmLoadding = false;
            this.$message.error(res.data.message);
          }
        },
        () => {
          this.confirmLoadding = false;
        }
      );
    },
    backZJ() {
      this.backZJVisible = true;
      this.isAppoint = 3;
    },
    shenhe() {
      this.isJob = 0;
      this.pvisible = true;
    },
    getJobDetail() {
      let _this = this;
      this.$get("/jobsmanage/jobs/detail/" + this.detailsData.jobsId).then(
        (res) => {
          this.jobDetail = res.data.data;
          this.getJobOutfileListByJobId(this.detailsData.jobsId);
        }
      );
    },
    getSplitMolecular(param) {
      let result = [];
      if (!param) {
        result = [];
      } else if (Array.isArray(param)) {
        result = param;
      } else {
        let mtSplit = param.split(",");
        mtSplit.forEach((item, i) => {
          mtSplit[i] = item * 1;
        });
        result = mtSplit;
      }
      return result;
    },
    getDetails(id) {
      this.selectRows = [];
      this.$get("report/report/detail/" + id).then((res) => {
        this.detailsData = res.data.data;
        this.molecular = this.getSplitMolecular(
          this.detailsData.molecularTyping
        );
        this.selectRows.push(this.detailsData);
        this.dataSource = this.detailsData.jobsVerifyRefVOList;
        this.reportUrlVOList = this.detailsData.reportUrlVOList;
        this.outfileList = this.detailsData.jobsFileRefList;
        if (this.detailsData.jobsId) {
          this.getJobDetail();
          this.jobsVerifyList();
        }
        this.getRemarkData(this.detailsData.bid);
      });
    },
    getRemarkData(id) {
      this.$get("patientitem/remarks?patientItemId=" + id).then((res) => {
        this.remarkData = res.data.data.records;
      });
    },
    okClick() {
      this.deleteReport();
    },
    // 审核组件
    // GET /api/jobverify/jobsVerifyRef/jobsVerifyList/{jobsId}
    jobsVerifyList() {
      this.$get(
        "/jobverify/jobsVerifyRef/jobsVerifyList/" + this.detailsData.jobsId
      ).then((res) => {
        this.verifyData = res.data.data;
      });
    },
    //输出文件设置
    // GET /api/joboutputfile/jobsFileRef/getJobOutfileListByJobId
    getJobOutfileListByJobId(id) {
      let flag = true;
      this.$get("/joboutputfile/jobsFileRef/getJobOutfileListByJobId", {
        id: id,
      }).then((res) => {
        this.dataStep1FileList = res.data.data;
        if (this.dataStep1FileList && this.dataStep1FileList.length > 0) {
          for (let item of this.dataStep1FileList) {
            if (item.editable) {
              if (item.optFileStatus != 2) {
                this.currentStep = 0;
                flag = false;
                break;
              } else {
                flag = true;
                this.currentStep = 1;
                this.fileDataZJ = null;
              }
            }
          }
          if (flag) {
            this.fileDataZJ = {};
            if (this.jobDetail.evidenceUrl) {
              this.fileDataZJ.name = this.jobDetail.evidenceName;
              if (
                this.jobDetail.verifyStatus == "1" ||
                this.jobDetail.verifyStatus == "2"
              ) {
                this.currentStep = 2;
                this.isSubmit = 1;
              } else {
                this.currentStep = 1;
                this.isSubmit = 1;
              }
            } else {
              this.currentStep = 1;
              this.fileDataZJ = null;
            }
          }
        }
      });
    },
    closeConfirm() {
      this.confirmVisible = false;
      this.getDetails(this.$route.query.id);
    },
    downFileByBlob(blob, fileName) {
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(link.href);
      }
    },
    downZJFile() {
      if (this.jobDetail.evidenceUrl) {
        let uploadFile = this.$db.get("uploadFile");
        axios
          .get(
            "/api/fileupload/downloadFiles?fileUrl=" +
            uploadFile.fileHost +
            this.jobDetail.evidenceUrl,
            {
              responseType: "arraybuffer",
            }
          )
          .then((res) => {
            var blob = new Blob([res.data]);
            this.downFileByBlob(blob, this.jobDetail.evidenceName);
          });
      }
    },
    downOutFile(item, type) {
      let uploadFile = this.$db.get("uploadFile");
      let fileUrl = type ? item.fileUrl : item.submissiontFileUrl;
      axios
        .get(uploadFile.fileHost + fileUrl, {}, { responseType: "blob" })
        .then((response) => {
          let blob = new Blob([response.data]);
          let downloadElement = document.createElement("a");
          let href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = type
            ? item.fileName
            : item.submissiontFileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        });
    },
    submitReportZJ() {
      this.loading = true;
      const formData = new FormData();
      formData.append("file", this.fileDataZJ);
      this.$upload("fileupload/upload", formData).then(
        (res) => {
          this.jobDetail.evidenceUrl = res.data.data.certifJpgFile;
          //   let num = this.fileData.name.toString().lastIndexOf('.')
          //  let type = this.fileData.name.substr(num+1,)
          // this.pvisible = true
          this.$post(
            "/jobsmanage/jobs/uploadEvidence",
            {
              evidenceName: this.fileDataZJ.name,
              evidenceSize: this.fileDataZJ.size,
              evidenceType: this.fileDataZJ.type,
              evidenceUrl: res.data.data.certifJpgFile,
              id: this.jobDetail.id,
            },
            true
          ).then((res) => {
            if (res.data.code == 1) {
              this.loading = false;
              this.$message.success("上传证据成功");
              this.isSubmit = 1;
              this.getJobDetail();
            } else {
              this.$message.error(res.data.message);
            }
          });
        },
        (err) => {
          this.loading = false;
        }
      );
    },
    submitReport() {
      let fileName = this.fileData.name;
      let extName = fileName.substring(fileName.lastIndexOf(".")).toLowerCase();
      if (extName != ".pdf") {
        this.$message.warning("请选择pdf文件");
        return;
      }
      const formData = new FormData();
      formData.append("file", this.fileData);
      this.$upload("fileupload/upload", formData).then(
        (res) => {
          this.$post(
            "report/report/uploadReport",
            {
              fileName: this.fileData.name,
              fileSize: this.fileData.size,
              fileType: this.fileData.type,
              reportId: this.detailsData.id,
              urlList: res.data.data.certifJpgFile,
            },
            true
          ).then((res) => {
            this.getDetails(this.$route.query.id);
          });
          this.fileData = null;
        },
        (err) => { }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.report-details {
  width: 100%;
  min-width: 1200px;

  .breadcrumb {
    /deep/ .ant-breadcrumb {
      display: inline-block;
    }
  }

  .anticon-close {
    cursor: pointer;
  }

  .table-th.link {
    margin: 0 5px;
  }

  .report-list {
    background: #fff;
    margin-top: 40px;

    .report-li {
      height: 60px;
      padding: 0 20px;

      &:hover {
        background: rgba(249, 252, 255, 1);
        box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.08);

        .report-li-td-icon {
          color: #ff2426;
        }
      }

      .report-li-td {
        width: 20%;
        float: left;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 60px;
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }

      .report-li-td-1 {
        width: 13%;
        text-align: center;
      }

      .report-li-td-2 {
        width: 14%;
      }

      .report-li-td:first-child {
        width: 60%;
      }

      .report-li-td-icon {
        text-align: right;

        .anticon {
          cursor: pointer;
        }
      }
    }

    .report-li+.report-li {
      border-top: 1px solid #f0f2f5;
    }
  }

  .report-details-content {
    background: #fff;
    padding-top: 25px;

    .m-input-s {
      width: 310px;
      margin: 10px 0 5px 0;
    }

    .result-table-step1 {
      background-color: #fff;

      /deep/ .hospital-table .ant-table-placeholder {
        min-height: 100px;
        height: 200px;
        line-height: 273px !important;
      }
    }

    .step3-status-text {
      font-size: 14px;
    }

    .mb15 {
      margin-bottom: 15px;
    }

    .step3-line {
      padding: 10px 0;
      border-top: 2px dashed #e1e2e5;
    }

    .step3-text-color {
      color: #428ef7;
    }

    .step3-list {
      margin-top: 0;

      .iconfont {
        margin-right: 5px;
        vertical-align: middle;
      }
    }

    .right-group {
      font-size: 14px;
      margin-left: 40px;

      .right-group-title {
        color: #a4a4a4;
        display: inline-block;
        margin-right: 10px;
      }

      .right-group-value {
        color: #333333;
      }
    }

    .mt-20 {
      margin-top: 20px;
    }

    .page-content {
      margin: 20px 2em 0;
    }

    .record-group {
      font-size: 14px;

      .record-title {
        color: #333;
      }

      .record-link {
        float: right;
        margin-right: 10%;
      }

      .record-esc {
        margin-right: -75px;
      }

      .record-none {
        float: right;
        text-align: left;
        margin-right: 10%;
        font-weight: 500;
      }
    }

    .mg-0 {
      margin-left: 0;
    }

    .mg-140 {
      margin-left: 140px;
    }

    .vefify-div {
      width: 100%;
      width: 100%;
      padding: 30px 40px;
      margin: 20px auto 0;
      min-height: 300px;
      min-width: 1120px;
      background: #fff;

      .table-vefify {
        margin-top: 40px;
      }

      .title {
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
    }

    .steps-div {
      background: #fff;
      padding: 0 40px 30px;
      border-bottom: 1px solid #f0f2f5;

      /deep/ .right-content {
        padding-bottom: 60px;

        .ant-upload-drag {
          margin-top: -15px;
          background: rgba(249, 252, 255, 1);
          border: 1px solid rgba(240, 242, 245, 1);
          box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.08);
        }

        .down-list {
          margin-top: -15px;
          line-height: 0;

          .down-file {
            background: #fff;
            padding: 16px 30px;
            display: inline-block;
            width: 100%;

            .down-li {
              width: 33%;
              max-width: 33%;
              overflow: hidden;
              line-height: 32px;
              text-overflow: ellipsis;
              white-space: nowrap;
              float: left;
            }

            .btn-down {
              text-align: right;
            }

            .down-li+.down-li {
              padding-left: 20px;
            }
          }
        }

        .file-div {
          width: 100%;
          height: 40px;

          .file {
            height: 32px;
            padding: 0 20px;
            background: rgba(249, 252, 255, 1);
            box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.08);
            font-size: 12px;
            float: left;
            font-family: PingFang SC;
            font-weight: 400;
            color: rgba(66, 142, 247, 1);
            line-height: 32px;
            width: calc(100% - 157px);
            max-width: 870px;
            margin-right: 50px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .file-show {
            width: calc(100%);
            max-width: 100%;
          }

          .file-btn {
            float: right;
            width: 107px;
          }
        }

        .mt10 {
          margin-top: 10px;
        }
      }

      /deep/ .examine-container {
        background: #eef1f5;
        width: 100%;
        padding: 75px 180px 0 266px;
        margin: 20px auto 0;
        min-height: 300px;
        min-width: 1120px;

        .ant-steps-vertical .ant-steps-item-title {
          width: calc(100% - 50px);
        }

        .table {
          background: #fff;
          margin-top: -15px;
        }

        .ant-steps-vertical .ant-steps-item-content {
          overflow: inherit;
          min-height: 100px;

          .btn-left {
            position: absolute;
            left: -239px;
            top: -15px;
            height: 65px;
            width: 166px;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #428ef7;
            text-align: right;
            line-height: 65px;

            .iconfont {
              margin-right: 10px;
              font-size: 22px;
              vertical-align: middle;
            }
          }
        }
      }
    }

    .header {
      padding: 0 40px 20px;
      border-bottom: 1px solid #f0f2f5;
      display: inline-block;
      width: 100%;

      .h-right-btn {
        text-align: right;
      }

      .ant-btn-primary {
        margin: 12px 0 12px 12px;
      }

      .left {
        float: left;
        max-width: calc(100% - 700px);
      }

      .right {
        float: right;
      }

      .name {
        font-size: 14px;
        color: #333;
        margin-bottom: 0;
      }

      .sex {
        margin-left: 22px;

        .anticon {
          font-size: 16px;
          color: #428ef7;
        }

        .set-text {
          font-size: 12px;
          font-family: PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          margin-left: 6px;
        }
      }

      .group {
        display: inline-block;
        height: 17px;
        font-size: 12px;
        padding: 0 10px;
        line-height: 17px;
        background: #428ef7;
        color: #fff;
        margin-left: 22px;
      }

      .create-date {
        margin-left: 70px;

        .title {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: rgba(164, 164, 164, 1);
        }

        .value {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          margin-left: 20px;
        }
      }
    }
  }
}

.user-name {
  font-size: 24px;
  color: #3870e1;
  line-height: 24px;
  margin: 20px 0 14px;
}

.disease-type {
  margin-left: 60px;
  border: 1px solid #3870e1;
  padding: 3px 8px;
  color: #3870e1;
  font-size: 12px;
  border-radius: 3px;
}

.user-sex {
  .icon-nan {
    margin-left: 56px;
    margin-right: 5px;
    font-size: 16px;
    color: #3870e1;
  }

  font-size: 14px;
  color: #333;
  line-height: 24px;
}

@media all and (max-width: 1400px) {
  .report-details .report-details-content .steps-div .examine-container {
    padding: 75px 100px 0 200px;
  }
}
</style>